import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminToken } from '../../services/adminApi';

const AdminAuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = getAdminToken();

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminAuthGuard;